import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const summaryReportService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/summary-report/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching report list", error);
            throw error;
        }
    },

    async generateReport(params: any): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/summary-report/generate/${params.trancheYear}/${params.trancheNumber}?isFirstCourse=${params.isFirstCourse}`);
            return response.data;
        } catch (error) {
            console.error("Error generate summary report", error);
            throw error;
        }
    },

    async findByReportUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/summary-report/findByReportUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findByReportUuid report", error);
            throw error;
        }
    },

    async save(report: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/summary-report/save`,
                report
            );
            return response.data;
        } catch (error) {
            console.error("Error save report", error);
            throw error;
        }
    },

    async deleteById(reportId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/summary-report/deleteById/${reportId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById report", error);
            throw error;
        }
    },

}

export default summaryReportService;
